import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { type FormQuestionState } from '@pixacare/forms';
import { TuiInput, TuiNumberFormat, type TuiNumberFormatSettings } from '@taiga-ui/core';
import { TuiInputNumber } from '@taiga-ui/kit';
import { FormDisplayMode } from '../../form-grid/models/form-display-mode';

@Component({
  selector: 'pxc-form-question-number',
  templateUrl: './form-question-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslocoDirective, TuiInput, TuiInputNumber, TuiNumberFormat],
})
export class FormQuestionNumberComponent {
  readonly control = input.required<AbstractControl>();
  readonly question = input.required<FormQuestionState>();
  readonly mode = input<FormDisplayMode>('form');
  readonly readOnly = input<boolean>(false);
  readonly iconStart = input<string>('');

  readonly numberFormat: Partial<TuiNumberFormatSettings> = { precision: 5, minimumFractionDigits: 0 };

  readonly unit = computed(() => this.question().parameters?.unit ?? '');
  readonly postfix = computed(() => (this.unit() ? ' ' + this.unit() : ''));
}
